import ImportantNotice from './ImportantNotice.jsx';

export default function HeroSection() {
  return (
    <header className="hero">
      <div className="hero__content">
        <div className="hero__copy">
          <p className="hero__eyebrow">Powering Gurugram and Nuh</p>
          <h1 className="hero__title">
            Register <span className="hero__title-accent">your interest</span>
          </h1>
          <p className="hero__lede">
            Eleven Power has been granted a parallel distribution licence for Gurugram and Nuh. Register to receive updates as our network reaches your area.
          </p>
        </div>

        <ImportantNotice />
      </div>
    </header>
  );
}
